/**
 * Helper for converting `\n` to `<br>`.
 *
 * @param {string} value Value to convert
 * @returns {string} Converted value
 * @author Philipp Seiler <sep@earlybird.at>
 */
const nl2br = (value: string): string => {
  if (value === undefined || !value) {
    return '';
  }
  const regExp = new RegExp(/\n/, 'g');
  return value.replace(regExp, '<br>');
};
export default nl2br;
